import React from 'react'
import { ButtonFloatingSettings, ButtonSettings } from './ButtonSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { Button as Original } from 'components/atoms'
import { getIcon } from 'utils/icons'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import {
  ctaDefaultProps,
  ctaItemParams,
} from 'react-pagebuilder/editor/Viewport/Sidebar/Toolbar/CtaToolbarSection'
import { getAncestorNode } from 'react-pagebuilder/utils/node'

export const defaultProps = {
  ...ctaDefaultProps('Button', '', 'right'),
  openNewTab: false,
  variant: 'primary',
  size: 'md',
  // theme e color dipendono dallo sfondo, in generale il contenuto libero è su sfondo chiaro quindi non serve settarli
}

export const buttonItemParams = (enabled, id, blockProps) => ({
  ...ctaItemParams(blockProps, enabled),
  pk: id,
  variant: blockProps.variant,
  blank: blockProps.openNewTab,
})

export const buttonParams = (enabled, blockProps) => ({
  label: blockProps.ctaLabel,
  href: enabled
    ? blockProps.url || blockProps.extUrl
      ? '#'
      : ''
    : blockProps.url || blockProps.extUrl,
  newPage: enabled ? false : blockProps.blank,
  icon: getIcon(blockProps.icon),
  iconPos: blockProps.iconPos,
  variant: blockProps.variant,
  size: blockProps.size,
})

export const dynamicProps = ['url']

export const Button: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }
    const { url, extUrl, openNewTab, variant, iconPos, icon, theme } = blockProps

    const { isSSR, children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled, parent } = useEditor(
      (state, query) => ({
        enabled: state.options.enabled,
        parent: getAncestorNode(id, query, 2),
      }),
      props
    )

    const parentTheme = parent?.data?.props?.block?.theme

    return enabled ? (
      <div ref={(ref) => props.retRef(ref)} className={'block-button ' + props.className}>
        <Original {...buttonParams(enabled, blockProps)} theme={parentTheme} />
      </div>
    ) : (
      <Original {...buttonParams(enabled, blockProps)} theme={parentTheme} />
    )
  },
  defaultProps,
  dynamicProps
)

Button.craft = withCraft({
  name: 'Button',
  defaultProps: defaultProps,
  settings: ButtonSettings,
  floatingSettings: ButtonFloatingSettings,
})
